import { render, staticRenderFns } from "./MessageBalloon.vue?vue&type=template&id=076bf063&scoped=true&"
import script from "./MessageBalloon.vue?vue&type=script&lang=js&"
export * from "./MessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./MessageBalloon.vue?vue&type=style&index=0&id=076bf063&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076bf063",
  null
  
)

export default component.exports